<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="form"
      @submit="handleCreate"
      @change="handleFormChange"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';
import _ from 'lodash';

@Component
export default class CategoriesNew extends Vue {

  form = {}
  firstLevelCategories = []
  secondLevelCategories = []

  get columns() {
    return createColumns({
      level: this.form.level,
      firstLevelCategories: this.firstLevelCategories,
      secondLevelCategories: this.secondLevelCategories,
      links: this.links
    });
  }

  get defaultLevel() {
    const parentLevel = _.get(this, '$route.query.parent_level');
    return parentLevel === 'first_level' ? 'second_level' : (parentLevel === 'second_level' ? 'third_level' : null);
  }

  async mounted() {
    this.form = {
      parent_id: _.get(this, '$route.query.parent_id'),
      level: this.defaultLevel,
      show_kind: 'left_right'
    };

    const [firstLevelCategories, secondLevelCategories, grouped_links] = await Promise.all([
      this.$request.get('/categories', { params: { simple_list: true, level_eq: 'first_level', per_page: 999 } }),
      this.$request.get('/categories', { params: { simple_list: true, level_eq: 'second_level', per_page: 999 } }),
      this.$request.get('/page_group_links')
    ]);
    this.firstLevelCategories = firstLevelCategories.data;
    this.secondLevelCategories = secondLevelCategories.data;
    this.links = _.map(grouped_links, (groupValue, groupLable) => {
      return {
        label: groupLable,
        options: _.map(groupValue, (value, label) => ({ value, label }))
      }
    });
  }

  async handleCreate(data) {
    const { id } = await this.$autoLoading(
      this.$request.post('/categories', data)
    );
    this.$router.push({ name: 'categories.show', params: { id } });
  }

  handleFormChange(data) {
    if (this.form.level !== data.level) {
      data.parent_id = null;
      data.show_kind = 'left_right';
    }
    this.form = data;
  }
}
</script>
